<template>
  <div class="card">
    <div class="card-header">
      <h6>Crear nuevo lead (Todos los campos son obligatorios)</h6>
    </div>
    <div class="card-body px-4">
      <div v-if="$userCan(['agent','supervisor'])" class="alert alert-warning py-2" style="font-size: 13px">
        El lead que crees quedará <b>pendiente de activación</b> por el administrador antes de poder usarse.
      </div>
      <form @submit.prevent="create">
      <div class="row">
        <div class="col">
          <label>Nombre</label>
          <input type="text" class="form-control" v-model="form.name">
          <label>Correo electrónico</label>
          <input type="email" class="form-control" v-model="form.email">
          <label>Identificación</label>
          <input type="text" class="form-control" v-model="form.identification">
        </div>
        <div class="col">
          <label>Teléfono</label>
          <input type="text" class="form-control" v-model="form.phone">
          <label>País</label>
          <input type="text" class="form-control" v-model="form.country">
          <label>Campaña</label>
          <input type="text" class="form-control" v-model="form.campaign">
          <button type="submit" class="btn bg-gradient-success mt-4 w-100"> Crear nuevo lead</button>
        </div>

      </div>
      </form>
    </div>
  </div>
</template>

<script>
import {post} from "@/utils/httpRequest";

export default {
  name: "index",
  data: () => ({
    form: {
      name: '',
      email: '',
      identification: '',
      phone: '',
      country: '',
      campaign: '',
      password: 'lead2023*',
      type: 'leads',
      token: '',
    }
  }),
  methods: {
    async create(){
      if(this.form.name !== '' && this.form.email !== '' && this.form.identification !== '' && this.form.phone !== '' && this.form.country !== '' && this.form.campaign !== ''){
        this.form.token = this.form.token.trim()
        const {data} = await post('users/create', this.form)
        if(data === 200){
          this.$swal({
            html: 'Proceso realizado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.$router.push('users')
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
@media (max-width: 767px) {
  .margin_top_mobile {
    margin-top: 1.5rem !important;
  }
}
</style>
